import { render, staticRenderFns } from "./add_editclr.vue?vue&type=template&id=3efab172&scoped=true&"
import script from "./add_editclr.vue?vue&type=script&lang=js&"
export * from "./add_editclr.vue?vue&type=script&lang=js&"
import style0 from "./add_editclr.vue?vue&type=style&index=0&id=3efab172&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efab172",
  null
  
)

export default component.exports